import React, { useContext, useEffect, useState } from "react";
import { GMCContext } from "../../GMCContext";
import Header from "../Common/Header";
import Sidebar from "../Common/Sidebar";
import Footer from "../Common/Footer";
import axios from "axios";
import Swal from "sweetalert2";

export default function WithdrawalOpenApproval() {
  const { setToken } = useContext(GMCContext);
  const statedata = JSON.parse(localStorage.getItem("mark#0143") || "null");

  const [authNumber, setAuthNumber] = useState("");
  const [error, setError] = useState(false);
  const [errorMessage, setErrorMessage] = useState("");
  const [msg, setMsg] = useState("");
  const [showMsg, setShowMsg] = useState(false);
  const [isVerified, setIsVerified] = useState(false);
  const [verifying, setVerifying] = useState(false);

  const [username, setUsername] = useState("");
  const [loadingUser, setLoadingUser] = useState(false);
  const [isUserFound, setIsUserFound] = useState(false);

  const [approvalType, setApprovalType] = useState("");
  const [submitting, setSubmitting] = useState(false);

  const insertCode = async () => {
    if (!authNumber.trim()) {
      setErrorMessage("Please enter authentication key.");
      setError(true);
      return;
    }

    try {
      setVerifying(true);
      setError(false);
      setErrorMessage("");

      const response = await axios.post(process.env.REACT_APP_BACKEND_LINK, {
        method: "verify",
        submethod: "insert",
        key: process.env.REACT_APP_KEY,
        authNumber,
        username: statedata?.username,
        _id: statedata?.id,
      });

      const { resCode, error: apiError, token } = response.data;

      if (resCode === 200 && token) {
        setMsg("Verified Successfully");
        setShowMsg(true);
        localStorage.setItem("mark#321", token);
        localStorage.setItem(
          "mark#0143",
          JSON.stringify({ username: statedata?.username, id: statedata?.id })
        );
        if (setToken) setToken(token);
        setIsVerified(true);
        setAuthNumber("");
      } else {
        setErrorMessage(apiError || "Verification Failed. Please Try Again.");
        setError(true);
      }
    } catch (err) {
      console.error("Error verifying auth key:", err);
      setErrorMessage("Network Error. Please Try Again Later.");
      setError(true);
    } finally {
      setVerifying(false);
    }
  };

  const fetchUser = async () => {
    if (!username.trim()) {
      Swal.fire("Error", "Enter Username", "error");
      return;
    }

    try {
      setLoadingUser(true);
      const res = await axios.post(process.env.REACT_APP_BACKEND_LINK, {
        method: "user",
        submethod: "profile",
        key: process.env.REACT_APP_KEY,
        username: username.trim(),
      });

      if (res.data?.resCode === 200) {
        setIsUserFound(true);
        setApprovalType("");
      } else {
        setIsUserFound(false);
        Swal.fire(
          "Error",
          res.data?.error || res.data?.message || "User not found",
          "error"
        );
      }
    } catch {
      setIsUserFound(false);
      Swal.fire("Error", "Server error", "error");
    } finally {
      setLoadingUser(false);
    }
  };

  const resetForm = () => {
    setUsername("");
    setIsUserFound(false);
    setApprovalType("");
  };

  const handleApprove = async () => {
    if (!isUserFound) {
      Swal.fire("Error", "Verify user first", "error");
      return;
    }

    if (!approvalType) {
      Swal.fire("Error", "Select Self or Team", "error");
      return;
    }

    const typeLabel = approvalType === "team" ? "Team" : "Self";
    const scopeText =
      approvalType === "team"
        ? "This user and all level users will be updated."
        : "Only this user will be updated.";

    const confirm = await Swal.fire({
      title: "Confirm Withdrawal Open Approval?",
      html: `
        <div style="text-align:left;">
          <p style="margin:0 0 8px;"><b>Username:</b> ${username.trim()}</p>
          <p style="margin:0 0 8px;"><b>Type:</b> ${typeLabel}</p>
          <p style="margin:0;color:#0d6efd;">${scopeText}</p>
        </div>
      `,
      icon: "question",
      showCancelButton: true,
      confirmButtonColor: "#405189",
      cancelButtonColor: "#6c757d",
      confirmButtonText: "Yes, Approve",
      cancelButtonText: "Cancel",
    });

    if (!confirm.isConfirmed) return;

    try {
      setSubmitting(true);

      const res = await axios.post(process.env.REACT_APP_BACKEND_LINK, {
        method: "admin",
        submethod: "greater",
        key: process.env.REACT_APP_KEY,
        username: username.trim(),
        type: approvalType,
        isGreater: true,
      });

      if (res.data?.resCode === 200) {
        const updatedCount = Number(res.data?.pagination?.total || 0);

        setSubmitting(false);
        await Swal.fire({
          title: "Success!",
          html: `
            <p style="margin:0 0 10px;">Withdrawal open approval completed successfully.</p>
            <p style="margin:0;font-size:18px;"><b>${updatedCount}</b> user(s) updated.</p>
          `,
          icon: "success",
          confirmButtonColor: "#405189",
        });

        resetForm();
        return;
      } else {
        Swal.fire(
          "Error",
          res.data?.message || res.data?.error || "Approval failed",
          "error"
        );
      }
    } catch (err) {
      console.error("Approve greater withdrawal error:", err);
      Swal.fire("Error", "Server error. Please try again.", "error");
    } finally {
      setSubmitting(false);
    }
  };

  useEffect(() => {
    if (!username.trim()) {
      setIsUserFound(false);
      setApprovalType("");
    }
  }, [username]);

  return (
    <>
      {submitting && (
        <div className="global-operation-blocker">
          <div className="blocker-content">
            <div className="spinning-ring" />
            <p className="fw-bold mb-0">Processing approval...</p>
            <small className="text-muted">Please wait</small>
          </div>
        </div>
      )}

      <Header />
      <Sidebar />

      <div
        className="buy-package-container"
        style={{
          opacity: submitting ? 0.5 : 1,
          pointerEvents: submitting ? "none" : "all",
        }}
      >
        <h2 className="buy-title">Withdrawal Open Approval</h2>

        <div className="structure-content">
          {!isVerified ? (
            <div className="glass-card auth-card">
              <div className="form-icon">
                <i className="ri-shield-keyhole-line" />
              </div>
              <h3>Verification Required</h3>
              <p>
                Please enter your authentication key to access withdrawal open
                approval.
              </p>
              <div className="input-field-wrapper">
                <input
                  type="text"
                  placeholder="Enter Auth Key"
                  value={authNumber}
                  onChange={(e) => setAuthNumber(e.target.value)}
                  onKeyDown={(e) => e.key === "Enter" && insertCode()}
                />
              </div>
              {error && errorMessage && (
                <div className="error-alert">{errorMessage}</div>
              )}
              {showMsg && msg && (
                <div className="success-alert">{msg}</div>
              )}
              <button
                className="primary-btn full"
                onClick={insertCode}
                disabled={verifying}
              >
                {verifying ? (
                  <i className="ri-loader-4-line spin" />
                ) : (
                  "Verify Access"
                )}
              </button>
            </div>
          ) : (
            <div className="main-structure-flow">
              <div className="glass-card search-card">
                <div className="input-field-wrapper">
                  <i className="ri-user-search-line prefix-icon" />
                  <input
                    type="text"
                    placeholder="Enter Username"
                    value={username}
                    onChange={(e) => setUsername(e.target.value)}
                    onKeyDown={(e) => e.key === "Enter" && !loadingUser && fetchUser()}
                    disabled={loadingUser}
                  />
                  <button
                    type="button"
                    className="search-btn"
                    onClick={fetchUser}
                    disabled={loadingUser || submitting}
                  >
                    {loadingUser ? (
                      <>
                        <span className="btn-inline-spinner" aria-hidden="true" />
                        Finding...
                      </>
                    ) : (
                      "Find User"
                    )}
                  </button>
                </div>
                {loadingUser && (
                  <div className="processing-indicator">
                    <div className="progress-track">
                      <div className="progress-fill indeterminate" />
                    </div>
                    <p className="loading-status">Searching user...</p>
                  </div>
                )}
              </div>

              {isUserFound && (
                <div className="glass-card form-card animate-slide-up">
                  <div className="form-header">
                    <h4>Approval Scope</h4>
                    <span className="badge">Verified: {username.trim()}</span>
                  </div>

                  <div className="type-selection-grid">
                    <label
                      className={`selectable-card ${
                        approvalType === "self" ? "active" : ""
                      }`}
                    >
                      <input
                        type="radio"
                        name="approvalType"
                        value="self"
                        checked={approvalType === "self"}
                        onChange={(e) => setApprovalType(e.target.value)}
                      />
                      <div className="card-content">
                        <i className="ri-user-3-line" />
                        <span>Self</span>
                        <small>Only this username</small>
                      </div>
                    </label>

                    <label
                      className={`selectable-card ${
                        approvalType === "team" ? "active" : ""
                      }`}
                    >
                      <input
                        type="radio"
                        name="approvalType"
                        value="team"
                        checked={approvalType === "team"}
                        onChange={(e) => setApprovalType(e.target.value)}
                      />
                      <div className="card-content">
                        <i className="ri-group-line" />
                        <span>Team</span>
                        <small>This user + level users</small>
                      </div>
                    </label>
                  </div>

                  <div className="action-footer">
                    <button
                      className="primary-btn"
                      onClick={handleApprove}
                      disabled={submitting || !approvalType}
                    >
                      {submitting ? (
                        <>
                          <i className="ri-loader-4-line spin" />
                          Processing...
                        </>
                      ) : (
                        "Confirm Approval"
                      )}
                    </button>
                    <button
                      className="secondary-btn"
                      onClick={resetForm}
                      disabled={submitting}
                    >
                      Reset
                    </button>
                  </div>
                </div>
              )}
            </div>
          )}
        </div>
      </div>

      <style>
        {`
          .buy-package-container {
            max-width: 800px;
            margin: 80px auto 40px;
            padding: 20px;
            font-family: 'Inter', system-ui, -apple-system, sans-serif;
          }

          .buy-title {
            font-size: clamp(24px, 5vw, 32px);
            font-weight: 800;
            background: linear-gradient(135deg, #405189, #1a2a6c);
            -webkit-background-clip: text;
            -webkit-text-fill-color: transparent;
            margin-bottom: 40px;
            text-align: center;
            letter-spacing: -1px;
          }

          .glass-card {
            background: rgba(255, 255, 255, 0.98);
            backdrop-filter: blur(12px);
            border: 1px solid rgba(226, 232, 240, 0.8);
            border-radius: 28px;
            padding: clamp(20px, 4vw, 40px);
            box-shadow: 0 15px 35px rgba(0, 0, 0, 0.03), 0 5px 15px rgba(64, 81, 137, 0.05);
          }

          .auth-card {
            text-align: center;
            max-width: 480px;
            margin: 0 auto;
          }

          .form-icon {
            font-size: 56px;
            background: linear-gradient(135deg, #405189, #2b3a67);
            -webkit-background-clip: text;
            -webkit-text-fill-color: transparent;
            margin-bottom: 24px;
          }

          .auth-card h3 {
            font-size: 24px;
            font-weight: 800;
            color: #1e293b;
            margin-bottom: 12px;
          }

          .auth-card p {
            color: #64748b;
            font-size: 15px;
            line-height: 1.7;
            margin-bottom: 30px;
          }

          .input-field-wrapper {
            position: relative;
            margin-bottom: 20px;
            display: flex;
            align-items: center;
            background: #f8fafc;
            border: 2px solid #f1f5f9;
            border-radius: 18px;
            padding: 6px 6px 6px 20px;
            transition: all 0.3s ease;
          }

          .input-field-wrapper:focus-within {
            border-color: #405189;
            background: #fff;
            box-shadow: 0 10px 25px rgba(64, 81, 137, 0.08);
          }

          .input-field-wrapper input {
            border: none;
            background: transparent;
            padding: 14px 12px;
            width: 100%;
            font-size: 16px;
            color: #1e293b;
            font-weight: 500;
            outline: none;
          }

          .prefix-icon {
            font-size: 20px;
            color: #94a3b8;
          }

          .primary-btn {
            background: linear-gradient(135deg, #405189, #2b3a67);
            color: white;
            border: none;
            padding: 16px 32px;
            border-radius: 18px;
            font-weight: 700;
            font-size: 16px;
            cursor: pointer;
            display: flex;
            align-items: center;
            justify-content: center;
            gap: 10px;
          }

          .primary-btn.full { width: 100%; }

          .primary-btn:disabled {
            opacity: 0.7;
            cursor: not-allowed;
          }

          .secondary-btn {
            background: #f1f5f9;
            color: #475569;
            border: none;
            padding: 16px 32px;
            border-radius: 18px;
            font-weight: 700;
            cursor: pointer;
          }

          .search-btn {
            background: #405189;
            color: white;
            border: none;
            padding: 12px 24px;
            border-radius: 14px;
            font-weight: 700;
            font-size: 14px;
            cursor: pointer;
            white-space: nowrap;
            min-width: 130px;
            display: inline-flex;
            align-items: center;
            justify-content: center;
            gap: 8px;
          }

          .search-btn:disabled {
            opacity: 0.9;
            cursor: wait;
          }

          .btn-inline-spinner {
            width: 16px;
            height: 16px;
            border: 2px solid rgba(255, 255, 255, 0.35);
            border-top-color: #fff;
            border-radius: 50%;
            animation: spin 0.8s linear infinite;
            flex-shrink: 0;
          }

          .processing-indicator {
            margin-top: 20px;
            background: #f8fafc;
            padding: 16px 18px;
            border-radius: 16px;
            border: 1px solid #f1f5f9;
          }

          .progress-track {
            height: 6px;
            background: #e2e8f0;
            border-radius: 10px;
            overflow: hidden;
            position: relative;
          }

          .progress-fill.indeterminate {
            width: 40%;
            height: 100%;
            background: linear-gradient(90deg, #405189, #2b3a67);
            position: absolute;
            left: -40%;
            animation: indeterminateProgress 1.5s infinite ease-in-out;
            border-radius: 10px;
          }

          @keyframes indeterminateProgress {
            0% { left: -40%; }
            100% { left: 140%; }
          }

          .loading-status {
            margin: 12px 0 0;
            font-size: 13px;
            font-weight: 700;
            color: #405189;
            text-align: center;
            letter-spacing: 0.3px;
          }

          .search-card { margin-bottom: 30px; }

          .form-header {
            display: flex;
            justify-content: space-between;
            align-items: center;
            margin-bottom: 30px;
            padding-bottom: 15px;
            border-bottom: 2px solid #f8fafc;
          }

          .form-header h4 {
            margin: 0;
            color: #1e293b;
            font-size: 20px;
            font-weight: 800;
          }

          .badge {
            background: #f0f4ff;
            color: #405189;
            padding: 8px 16px;
            border-radius: 24px;
            font-size: 13px;
            font-weight: 700;
          }

          .type-selection-grid {
            display: grid;
            grid-template-columns: repeat(auto-fit, minmax(180px, 1fr));
            gap: 16px;
            margin-bottom: 35px;
          }

          .selectable-card {
            cursor: pointer;
            position: relative;
          }

          .selectable-card input {
            position: absolute;
            opacity: 0;
          }

          .card-content {
            background: #fff;
            border: 2px solid #f1f5f9;
            border-radius: 22px;
            padding: 24px;
            text-align: center;
            transition: all 0.3s ease;
            display: flex;
            flex-direction: column;
            align-items: center;
            gap: 10px;
          }

          .card-content i {
            font-size: 32px;
            color: #94a3b8;
          }

          .card-content span {
            font-weight: 800;
            color: #334155;
            font-size: 17px;
          }

          .card-content small {
            font-size: 12px;
            color: #64748b;
          }

          .selectable-card.active .card-content {
            border-color: #405189;
            background: rgba(64, 81, 137, 0.03);
          }

          .selectable-card.active .card-content i,
          .selectable-card.active .card-content span {
            color: #405189;
          }

          .action-footer {
            display: flex;
            gap: 15px;
          }

          .error-alert {
            color: #dc2626;
            background: #fef2f2;
            padding: 14px;
            border-radius: 14px;
            margin-bottom: 20px;
            font-size: 14px;
            font-weight: 600;
          }

          .success-alert {
            color: #16a34a;
            background: #f0fdf4;
            padding: 14px;
            border-radius: 14px;
            margin-bottom: 20px;
            font-size: 14px;
            font-weight: 600;
          }

          .animate-slide-up {
            animation: slideUp 0.6s cubic-bezier(0.23, 1, 0.32, 1) forwards;
          }

          @keyframes slideUp {
            from { transform: translateY(30px); opacity: 0; }
            to { transform: translateY(0); opacity: 1; }
          }

          .spin { animation: spin 1s linear infinite; }
          @keyframes spin {
            from { transform: rotate(0deg); }
            to { transform: rotate(360deg); }
          }

          .global-operation-blocker {
            position: fixed;
            inset: 0;
            background: rgba(15, 23, 42, 0.45);
            z-index: 9999;
            display: flex;
            align-items: center;
            justify-content: center;
          }

          .blocker-content {
            background: white;
            padding: 40px;
            border-radius: 30px;
            box-shadow: 0 25px 50px -12px rgba(0, 0, 0, 0.15);
            text-align: center;
            display: flex;
            flex-direction: column;
            align-items: center;
            gap: 15px;
          }

          .spinning-ring {
            width: 80px;
            height: 80px;
            border: 4px solid #f1f5f9;
            border-top: 4px solid #405189;
            border-radius: 50%;
            animation: spin 1s linear infinite;
          }

          @media (max-width: 640px) {
            .action-footer { flex-direction: column; }
            .primary-btn, .secondary-btn { width: 100%; }
            .form-header { flex-direction: column; align-items: flex-start; gap: 12px; }
          }
        `}
      </style>

      <Footer />
    </>
  );
}
